module.exports = __webpack_public_path__ + "img/bg_1.75e4d857.png";